const PurchaseReturn_sample = [
  {
    orderData: {
      prt_id: "prt_id",
      store_id: "store_id",
      cmr_phone_number: "cmr_phone_number",
      remarks: "remarks",
      prt_total_gst: "prt_total_gst",
      prt_total_discount: "prt_total_discount",
      prt_payment_status: "prt_payment_status",
      prt_transaction_id: "prt_transaction_id",
      prt_order_status: "prt_order_status",
      prt_payment_method: "prt_payment_method",
      prt_billing_address: "prt_billing_address",
      prt_total_amount: "prt_total_amount",
      prt_round_off_value: "prt_round_off_value",
      prt_sub_total: "prt_sub_total",
      prt_delivery_date: "prt_delivery_date",
      prt_document_date: "prt_document_date",
      cmr_code: "cmr_code",
      cmr_name: "cmr_name",
      cmr_id: "cmr_id",
      created_date: "created_date",
      update_date: "update_date",
      tcs_or_tds_amount: "tcs_or_tds_amount",
      tcs_or_tds_percentage: "tcs_or_tds_percentage",
      tds_tcs_type: "tds_tcs_type",
      tcs_or_tds_percentage_id: "tcs_or_tds_percentage_id",
      prt_invoice_discount: "prt_invoice_discount",
      prt_invoice_discount_percentage: "prt_invoice_discount_percentage",
      prt_is_invoice_dis_percentage: "prt_is_invoice_dis_percentage",

      prt_ship_to_address: {
        cmr_id: "cmr_id",
        update_date: "update_date",
        created_date: "created_date",
        cmr_default_address: "cmr_default_address",
        cmr_ship_address_id: "cmr_ship_address_id",
        cmr_ship_address_city: "cmr_ship_address_city",
        cmr_ship_address_name: "cmr_ship_address_name",
        cmr_ship_address_town: "cmr_ship_address_town",
        cmr_ship_address_state: "cmr_ship_address_state",
        cmr_ship_address_street: "cmr_ship_address_street",
        cmr_ship_address_address: "cmr_ship_address_address",
        cmr_ship_address_country: "cmr_ship_address_country",
        cmr_ship_address_pincode: "cmr_ship_address_pincode",
        cmr_ship_address_district: "cmr_ship_address_district",
      },

      prt_pay_to_address: {
        cmr_id: "cmr_id",
        update_date: "update_date",
        created_date: "created_date",
        cmr_pay_address_id: "cmr_pay_address_id",
        cmr_default_address: "cmr_default_address",
        cmr_pay_address_city: "cmr_pay_address_city",
        cmr_pay_address_name: "cmr_pay_address_name",
        cmr_pay_address_town: "cmr_pay_address_town",
        cmr_pay_address_state: "cmr_pay_address_state",
        cmr_pay_address_street: "cmr_pay_address_street",
        cmr_pay_address_address: "cmr_pay_address_address",
        cmr_pay_address_country: "cmr_pay_address_country",
        cmr_pay_address_pincode: "cmr_pay_address_pincode",
        cmr_pay_address_district: "cmr_pay_address_district",
      },
    },
    itemData: [
      {
        item_id: "item_id",
        item_code: "item_code",
        item_generic_name: "item_generic_name",
        item_name: "item_name",
        gort_id: "gort_id",
        item_rack_location: "item_rack_location",
        item_unit_price: "item_unit_price",
        item_quantity: "item_quantity",
        item_schedule: "item_schedule",
        item_discount_amount: "item_discount_amount",
        item_discount_percentage: "item_discount_percentage",
        item_tax_amount: "item_tax_amount",
        item_uom: "item_uom",
        item_credit_quanity_remaining: "item_credit_quanity_remaining",
        item_total_tax_percentage: "item_total_tax_percentage",
        item_total_amount: "item_total_amount",
        item_gst: "item_gst",
        item_sgst: "item_sgst",
        item_cgst: "item_cgst",
        item_igst: "item_igst",
        item_free_quantity: "item_free_quantity",
        item_hsn: "item_hsn",
        item_manufacturer_id: "item_manufacturer_id",
        item_manufacturer_name: "item_manufacturer_name",
        item_pack_size: "item_pack_size",
        base_quantity: "base_quantity",
        itemBatchData: [
          {
            item_id: "item_id",
            item_batch_number: "item_batch_number",
            item_sellable_quantity: "item_sellable_quantity",
            item_non_sellable_quantity: "item_non_sellable_quantity",
            item_exp_date: "item_exp_date",
            item_mfg_date: "item_mfg_date",
            item_batch_free_quantity: "item_batch_free_quantity",
            item_batch_unit_price: "item_batch_unit_price",
            item_batch_purchase_rate: "item_batch_purchase_rate",
            item_batch_discount_percentage: "item_batch_discount_percentage",
            item_batch_discount_amount: "item_batch_discount_amount",
            item_batch_tax_amount: "item_batch_tax_amount",
            item_batch_tax_percentage: "item_batch_tax_percentage",
            item_batch_final_purchase_rate: "item_batch_final_purchase_rate",
            item_batch_total_purchase_rate: "item_batch_total_purchase_rate",
            to_bin_id: "to_bin_id",
            to_bin_location: "to_bin_location",
          }
        ],
        total_sellable_quantity: "total_sellable_quantity",
      }
    ]
  }
];
const storeDetailsResult_sample = [
  {
    company: "COMAPNY_NAME",
    company_address: "COMPANY_LOCATION",
    company_telephone1: "COMPANY_PHONE",
    company_city: "COMPANY_CITY_CODE",
    company_gstn: "COMPANY_GST_NUMBER",
    company_email: "COMPANY_EMAIL",
    dl_no_20_20b: "DRUG_LICENSE_XX_XX",
    dl_no_21_21b: "DRUG_LICENSE_XX_XX",
    dl_no_21c: "DRUG_LICENSE_21C",
    store_id: "STORE_ID",
    company_logo: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSQVa-2-bOT2c7AJwxiSHkrkwOkey9z9x16dA&s"
  }
];
export default {PurchaseReturn_sample,storeDetailsResult_sample};
